import api from "./api.js";

export default class WritingLinkApi {
  static async getSettingStatus() {
    return await api.get(`api/writing-link`); // 라이팅링크 설정 상태 조회
  }

  static async updateSettingStatus(data) {
    return await api.patch(`api/writing-link/activation`, data); // 라이팅링크 설정 상태 수정
  }

  static async getListHistory(params) {
    return await api.get(`api/writing-link-history`, params);
  }

  static async getByIdHistory(id) {
    return await api.get(`api/writing-link-history/${id}`);
  }

  static async updateCash(id, data) {
    return await api.patch(`api/writing-link-history/cash/${id}`, data);
  }

  static async updateDistribute(id, data) {
    return await api.patch(`api/writing-link-history/distribute/${id}`, data);
  }

  static async updateMemo(id, data) {
    return await api.patch(`api/writing-link-history/memo/${id}`, data);
  }

  static async updatePoint(data) {
    return await api.patch(`api/writing-link-history/point`, data);
  }
}
